import SettingsFieldHelpPopover from '../Common/SettingsFieldHelpPopover';

const STATUS_GUIDE = [
  {
    heading: 'Draft',
    body: 'Work in progress. A planned send date is calendar-only — nothing queues or sends. Move to Scheduled when you are committed to the send.',
  },
  {
    heading: 'On Hold',
    body: 'Paused. No auto-queue and no sends until you move back to Draft or Scheduled.',
  },
  {
    heading: 'Scheduled',
    body: 'Committed to send on the planned date. Recipients auto-queue about 24 hours before send (every 30 minutes), or use Actions → Queue recipients anytime sooner.',
  },
  {
    heading: 'Ready to Publish',
    body: 'Recipients are queued (one scheduled_emails row per subscriber). Mail goes out at or shortly after the planned time. Purge scheduled on Recipients returns to Draft.',
  },
  {
    heading: 'Published',
    body: 'Send pipeline finished: planned time has passed and there are no pending recipient rows.',
  },
] as const;

export default function NewsletterStatusHelpPopover() {
  return (
    <SettingsFieldHelpPopover
      panelTitle="Status meanings"
      ariaLabel="Newsletter status guide"
      intro={
        <>
          Set status to{' '}
          <strong className="font-semibold text-gray-700 dark:text-gray-200">Scheduled</strong> when
          you are done editing and want the send to happen. Draft + a date alone does not queue
          recipients.
        </>
      }
      sections={STATUS_GUIDE.map((item) => ({ heading: item.heading, body: item.body }))}
    />
  );
}
